// Copyright (c) 2018 Deere & Company

import * as busyCounter from './busy-counter';
import {readExcelLayouts} from './read-excel-layouts';
import {saveExcelLayout as saveExcelLayoutObject} from '../repositories';
import {successAlertBar} from '../../shared/services/alert-bar';
import {translate} from '../services/translation-service';
import {updateExcelLayoutModalVisibility} from './excel-layout-modal';

export const saveExcelLayout = (excelLayout, feature) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await saveExcelLayoutObject(excelLayout);

            updateExcelLayoutModalVisibility(false)(dispatch);

            successAlertBar(translate('LAYOUT_UPDATED_SUCCESSFULLY'));

            readExcelLayouts(feature)(dispatch);

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/shared/action-creators/save-excel-layout.js